import { isEqual, noop } from 'lodash';
import { useEffect } from 'react';
import { Control, useFieldArray, UseFormWatch } from 'react-hook-form';

import { GraphNodeProperty } from 'dashboard/components/FormControls/GraphNodeConfigurationRow/GraphNodeProperty';
import { GraphNodeConfigFormData } from 'dashboard/forms/FormGraphNodeConfiguration/FormGraphNodeConfiguration';
import { GraphProperty, PropertySource } from 'dashboard/models/graph/node-render-config';
import { ServerNodeRenderConfig } from 'dashboard/models/graph-backend';
import Card from 'design-system/components/Card';
import { FieldSchema } from 'lib/fields';

interface HoverCardPropertiesTabProps {
  control: Control<GraphNodeConfigFormData>;
  watch: UseFormWatch<GraphNodeConfigFormData>;
  nodeRenderConfig: ServerNodeRenderConfig;
  defaultGraphProperties: GraphProperty[];
  nodeKeySchema: FieldSchema[];
  isCustomNode: boolean;
}

const HoverCardPropertiesTab = ({
  control,
  watch,
  defaultGraphProperties,
  nodeKeySchema,
  isCustomNode,
}: HoverCardPropertiesTabProps) => {
  const { move, remove, append, replace } = useFieldArray<GraphNodeConfigFormData>({
    control,
    name: 'nodeRenderConfig.context-menu',
  });
  const properties = watch('nodeRenderConfig.context-menu');

  useEffect(() => {
    if (!isCustomNode) {
      return;
    }

    const nodePropertiesMatchNodeKeySchema = isEqual(
      properties.map((property) => property.value).sort(),
      nodeKeySchema.map((schema) => schema.key).sort(),
    );

    // If we ever get into a state where this isn't true (ex. changing node key schema), reset hover card properties
    if (!nodePropertiesMatchNodeKeySchema) {
      replace(
        nodeKeySchema.map((schema) => ({
          source: PropertySource.Persona,
          value: schema.key,
        })),
      );
    }
  }, [nodeKeySchema, properties, replace, isCustomNode]);

  return (
    <Card>
      <Card.Body>
        <GraphNodeProperty
          nodeProperties={properties}
          defaultGraphProperties={defaultGraphProperties}
          move={move}
          remove={remove}
          append={append}
          // TODO(unzi): Update when allowing form updates. Should disable save and publish button while editing
          onGraphConfigEdit={noop}
          isCustomNode={isCustomNode}
        />
      </Card.Body>
    </Card>
  );
};

export default HoverCardPropertiesTab;
